/** Whether this server lets a teacher open their own account; "off" until it says otherwise,
 * so a slow or older server never shows a form it would refuse. */
import { useQuery } from "@tanstack/react-query";

import { teacherSignupPolicy } from "./session";
import type { SignupPolicy } from "./signupRules";

export function useSignupPolicy(): { policy: SignupPolicy; loading: boolean } {
  const q = useQuery({ queryKey: ["auth", "signup", "teacher"], queryFn: teacherSignupPolicy, retry: false, staleTime: 5 * 60_000 });
  return { policy: q.data ?? "off", loading: q.isPending };
}
